import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'

export const useHeader = () => {
  const { authenticated, planType, userType } = useSelector(selectUserConfiguration)

  return { authenticated, planType, userType }
}
